
import Vue from 'vue';
import Clipboard from 'clipboard';
import { Toast } from "vant";

export const clipboardSuccess = () => {
  Toast('复制成功')
}

export const clipboardError = () => {
  Toast('复制失败')
}

export const handleClipboard = async (text, event) => {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  });
  clipboard.on('success', () => {
    clipboardSuccess();
    clipboard.destroy();
  });
  clipboard.on('error', () => {
    clipboardError();
    clipboard.destroy();
  });
  clipboard.onClick(event);
};
// 并列数组
export const doExchange = arr => {
  var len = arr.length
  if (len >= 2) {
      var len1 = arr[0].length
      var len2 = arr[1].length
      var lenBoth = len1 * len2
      var items = new Array(lenBoth)
      var index = 0
      for (var i = 0; i < len1; i++) {
          for (var j = 0; j < len2; j++) {
              items[index] = arr[0][i] + '|' + arr[1][j]
              index++
          }
      }
      var newArr = new Array(len - 1)
      // eslint-disable-next-line no-redeclare
      for (var i = 2; i < arr.length; i++) {
          newArr[i - 1] = arr[i]
      }
      newArr[0] = items
      return doExchange(newArr)
  } else {
      return arr[0]
  }
}